import Master from "./utils/Master";
import { useEffect } from "react";
import { useContext } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";

const ProctedRoutes = ({ children }) => {
  const { token } = useContext(Master);
  // console.log(
  //     "Protected route - token:", token
  // );
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("certificaterole") === null) {
      navigate("/login");
    }

    // return () => {

    // 	if(localStorage.getItem("certificaterole") != null){
    // 	  localStorage.removeItem("certificaterole");
    // 	}
    // }
  }, [navigate]);

  if (!token) {
    return <Navigate to="/login" replace />;
  } else {
    return <Outlet />;
  }
};

export default ProctedRoutes;
